export const getBookingLinkUrl = (token: string) => `${import.meta.env.VITE_MONOLITH_HOST}/ticket/${token}`;
